import React from "react"
import * as Icons from "lucide-react"

/**
 * Outlook-style module switcher rail (bottom-left).
 * Compact, icon-only: Mail, Calendar, People, To Do, and a "More" (…) button.
 */
const NAV_ITEMS = [
  { key: "mail", label: "Mail", icon: Icons.Mail },
  { key: "calendar", label: "Calendar", icon: Icons.Calendar },
  { key: "people", label: "People", icon: Icons.Users },
  { key: "tasks", label: "To Do", icon: Icons.CheckSquare },
]

export default function EmailNavRail({
  activeView,
  onChangeView,
  unread = 0,
  onMore,
}) {
  return (
    <div className="em-nav-rail">
      <div className="em-nav-rail-top">
        {NAV_ITEMS.map(item => {
          const IconComp = item.icon
          const isActive = activeView === item.key
          return (
            <button
              key={item.key}
              className={`em-nav-rail-btn ${
                isActive ? "em-nav-rail-btn-active" : ""
              }`}
              title={item.label}
              onClick={() => onChangeView(item.key)}
              type="button"
            >
              <span className="em-nav-rail-icon">
                <IconComp size={20} />
                {item.key === "mail" && unread > 0 && (
                  <span className="em-nav-rail-badge">
                    {unread > 99 ? "99+" : unread}
                  </span>
                )}
              </span>
            </button>
          )
        })}
        <button
          className="em-nav-rail-btn em-nav-rail-more"
          title="More apps"
          onClick={() => onMore && onMore()}
          type="button"
        >
          <span className="em-nav-rail-icon">
            <Icons.MoreHorizontal size={20} />
          </span>
        </button>
      </div>
    </div>
  )
}
